import httpClientAuthorizer from './HttpClientAuthorizer';
import httpClient from '../HttpClient';
export default class ERPAdapter {
  constructor(keycloakIDPAdapter, apiUrl, newApiUrl) {
    this.keycloakIDPAdapter = keycloakIDPAdapter;
    this.apiUrl = apiUrl;
    this.newApiUrl = newApiUrl;
  }
  request(method, endpoint, data, onSuccess, onError) {
    this.keycloakIDPAdapter.getClient().updateToken(0).then(result => {
      const url = `${this.apiUrl}/${endpoint}`;
      const config = httpClientAuthorizer.authorizeRequestConfig(this.keycloakIDPAdapter, {});
      httpClient.request({
        method: method,
        url: url,
        data: data,
        onSuccess: onSuccess,
        onError: onError,
        config: config
      });
    });
  }
  requestWithDelay(method, endpoint, data, onSuccess, onError, delay) {
    this.keycloakIDPAdapter.getClient().updateToken(0).then(result => {
      const url = `${this.apiUrl}/${endpoint}`;
      const config = httpClientAuthorizer.authorizeRequestConfig(this.keycloakIDPAdapter, {});
      httpClient.requestWithDelay({
        method: method,
        url: url,
        data: data,
        config: config,
        onSuccess: onSuccess,
        onError: onError,
        ignoreError: false,
        delay: delay
      });
    });
  }
  fetch(method, endpoint, data, onSuccess, onError) {
    this.keycloakIDPAdapter.getClient().updateToken(0).then(result => {
      const url = `${this.newApiUrl}/${endpoint}`;
      const config = httpClientAuthorizer.authorizeRequestConfig(this.keycloakIDPAdapter, {});
      httpClient.request({
        method: method,
        url: url,
        data: data,
        onSuccess: onSuccess,
        onError: onError,
        config: config
      });
    });
  }
  fetchWithDelay(method, endpoint, data, onSuccess, onError, delay) {
    this.keycloakIDPAdapter.getClient().updateToken(0).then(result => {
      const url = `${this.newApiUrl}/${endpoint}`;
      const config = httpClientAuthorizer.authorizeRequestConfig(this.keycloakIDPAdapter, {});
      httpClient.requestWithDelay({
        method: method,
        url: url,
        data: data,
        config: config,
        onSuccess: onSuccess,
        onError: onError,
        ignoreError: false,
        delay: delay
      });
    });
  }
}